import Size from '@enums/Size';
import InputLabel from '@mui/material/InputLabel';
import LabelSize from './utils/labelSize';

const Label = ({ children, size = Size.MEDIUM }) => {
  const sizeProps = LabelSize[size];
  return (
    <InputLabel disableAnimation shrink={false} sx={{ ...sizeProps, mb: 0.5 }}>
      {children}
    </InputLabel>
  );
};

export default Label;
